// extracted by mini-css-extract-plugin
module.exports = {"title":"title__2bdCXH++h+Fma","param_block":"param_block__HrOHIxLI21kuE"};